import { useState, useEffect } from "react";

export function useMessages(locale: string) {
  const [messages, setMessages] = useState<Record<string, string> | undefined>(undefined);

  useEffect(() => {
    //import(`/messages/${locale}.json`)
    import(`@/datas/messages/${locale}.json`)
      .then((mod) => setMessages(mod.default))
      .catch((error) => console.error("Failed to load messages", error));
  }, [locale]);

  return messages;
}
